export default __webpack_public_path__ + "static/media/zh-TW_Wall.a9466824.png";